/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Perks_Trigger_Tenure_OneInputs */



/**
* | output |
* | --- |
* | "{days} day in the server" |
*
* @param {Perks_Trigger_Tenure_OneInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_trigger_tenure_one = /** @type {((inputs: Perks_Trigger_Tenure_OneInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Trigger_Tenure_OneInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.days} день на сервере`)
	return /** @type {LocalizedString} */ (`${i?.days} day in the server`)
});